import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export const classnames = (...classes: any[]) => twMerge(clsx(...classes));
